import React, { useState, useEffect } from 'react';

import { addSeconds, differenceInSeconds } from 'date-fns';

import { l10n } from '@ott/l10n';

import styles from './ResendSMS.scss';

type Props = {
  onClick: VoidFunction;
};

const PHONE_BLOCK_TIME = 30;

const ResendSMS = ({ onClick }: Props) => {
  const [seconds, setSeconds] = useState(0);
  const [dueDate, setDueDate] = useState(addSeconds(Date.now(), PHONE_BLOCK_TIME));

  let timer: ReturnType<typeof setTimeout>;

  const calculateTime = () => {
    let time = differenceInSeconds(dueDate, Date.now());

    if (time < 0) {
      time = 0;
    }
    setSeconds(time);

    if (time <= 0) {
      clearTimeout(timer);

      return;
    }
    timer = setTimeout(() => calculateTime(), 1000);
  };

  const handleClick = () => {
    setDueDate(addSeconds(Date.now(), PHONE_BLOCK_TIME));
    onClick();
  };

  useEffect(() => {
    calculateTime();

    return () => {
      clearTimeout(timer);
    };
  }, [dueDate]);

  if (seconds) {
    return (
      <span className={styles.notice} data-locator="resend-timeout-text">
        {l10n('virtualCard.releaseForm.resend.status', { timer: seconds })}
      </span>
    );
  }

  return (
    <button
      type="button"
      className={styles.resend}
      onClick={handleClick}
      data-locator="virtual-card-resend-pin-button"
    >
      {l10n('virtualCard.releaseForm.resend.action')}
    </button>
  );
};

export default ResendSMS;
